import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { useLoginCalls } from '../../login/hooks/login-calls.hook'
import { setAuthData } from '../../global'
import { loadLocalStorage, saveLocalStorage } from '../../../core/utils'
import { resetApplications } from '../../gas-applications/slices/gas-applications.slice'
export const useGlobalActions = () => {
  const { loginCall, revokeTokenCall } = useLoginCalls()
  const dispatch = useDispatch()

  const loginUser = useCallback(
    (payload) =>
      new Promise((resolve, reject) => {
        loginCall(payload)
          .then(({ data }) => {
            saveLocalStorage('dsc', { 'apc-auth': data })
            dispatch(setAuthData({ ...data, isAuthorized: true }))
          })
          .then((response) => resolve(response))
          .catch((response) => {
            return reject(response)
          })
      }),
    [loginCall, dispatch]
  )

  const logoutUser = useCallback(() => {
    const authData = loadLocalStorage('apc-auth')

    dispatch(setAuthData({ isAuthorized: false }))
    dispatch(resetApplications())

    saveLocalStorage('dsc', { 'apc-auth': {} })

    if (authData?.token && authData?.refresh_token) {
      revokeTokenCall(authData).catch(() => {
        console.warn(
          'La revocación del token en el servidor falló, pero el usuario ya cerró sesión en el cliente.'
        )
      })
    }
  }, [revokeTokenCall, dispatch])

  return {
    loginUser,
    logoutUser,
  }
}
